import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HiMenu, HiX } from "react-icons/hi";
import "./Navbar.css";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavClick = (sectionId) => {
    setIsOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" className="nav-logo">
          <span className="logo-text">WTF⚡Horoscope</span>
        </Link>

        {/* Desktop Menu */}
        <div className="nav-menu-desktop">
          <a href="#home" onClick={() => handleNavClick("home")} className="nav-link">
            Home
          </a>
          <a href="#zodiac-grid" onClick={() => handleNavClick("zodiac-grid")} className="nav-link">
            Zodiac Signs
          </a>
          <a href="#how-it-works" onClick={() => handleNavClick("how-it-works")} className="nav-link">
            How It Works
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle menu">
          {isOpen ? <HiX size={24} /> : <HiMenu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <motion.div
        className={`nav-menu-mobile ${isOpen ? "open" : ""}`}
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: isOpen ? 1 : 0, height: isOpen ? "auto" : 0 }}
        transition={{ duration: 0.3 }}
      >
        <a
          href="#home"
          className="mobile-nav-link"
          onClick={() => handleNavClick("home")}
        >
          Home
        </a>
        <a
          href="#zodiac-grid"
          className="mobile-nav-link"
          onClick={() => handleNavClick("zodiac-grid")}
        >
          Zodiac Signs
        </a>
        <a
          href="#how-it-works"
          className="mobile-nav-link"
          onClick={() => handleNavClick("how-it-works")}
        >
          How It Works
        </a>
      </motion.div>
    </nav>
  );
};
